var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChapterEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.857 1.59802C10.1743 0.909778 9.07665 0.909778 8.39393 1.59802L1.76075 8.26728C1.59959 8.43414 1.50495 8.63108 1.47809 8.83256L1.47752 8.8368L1.11383 11.409L3.20657 11.1116V11.1003L3.676 11.0377C3.87956 11.0105 4.06788 10.9161 4.21185 10.7632L4.21696 10.7578L10.8575 4.08113L10.8585 4.08009C11.5408 3.39785 11.543 2.28951 10.857 1.59802ZM7.62626 0.835741C8.7322 -0.278706 10.5193 -0.27858 11.625 0.836118C12.7275 1.9475 12.7299 3.73806 11.6241 4.84452L11.6235 4.84508L4.99411 11.5105C4.79258 11.7229 4.55129 11.8837 4.2884 11.9878V12.0505L1.03246 12.5133L1.03076 12.5135C0.758951 12.5513 0.471088 12.4793 0.259753 12.2706C0.0472111 12.0606 -0.0282318 11.7712 0.00920402 11.4942L0.00964539 11.4909L0.406043 8.68729C0.466012 8.24144 0.673469 7.8342 0.986522 7.51164L0.991122 7.50692L7.62626 0.835741Z",
    fill: "#14489F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79031 2.69996C10.0023 2.91041 10.0036 3.2529 9.79321 3.46494L8.83401 4.43137C8.62357 4.64341 8.28106 4.6447 8.06906 4.43427C7.85702 4.22383 7.85572 3.88132 8.06616 3.66928L9.02536 2.70284C9.2358 2.49081 9.57831 2.48952 9.79031 2.69996Z",
    fill: "#14489F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33948 13.5292C7.33948 13.2304 7.58164 12.9883 7.8804 12.9883H12.0851C12.3839 12.9883 12.6261 13.2304 12.6261 13.5292C12.6261 13.8279 12.3839 14.0701 12.0851 14.0701H7.8804C7.58164 14.0701 7.33948 13.8279 7.33948 13.5292Z",
    fill: "#14489F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterEdit);
export default __webpack_public_path__ + "static/media/chapter_edit.80f789f718c85f8487f381bb9bc1eb39.svg";
export { ForwardRef as ReactComponent };